var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInnovationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1V5M11 17V21M21 11H17M5 11H1M3.929 3.929L6.757 6.757M15.243 15.243L18.071 18.071M18.071 3.929L15.243 6.757M6.757 15.243L3.93 18.07",
    stroke: "url(#paint0_linear_842_1794)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_842_1794",
    x1: 0.637133,
    y1: 11.4196,
    x2: 21.326,
    y2: 11.4196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6430E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#895EF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovationIcon);
export default __webpack_public_path__ + "static/media/innovation-icon.3ed0ce40bcb03fa3a9b055d628795a22.svg";
export { ForwardRef as ReactComponent };